var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.localizedDateTime = exports.elideIfLong = void 0;
var _ = __importStar(require("underscore"));
var Localize_1 = require("../../gen-src/Localize");
function elideIfLong(s, maxLength) {
    if (maxLength === void 0) { maxLength = 100; }
    if (!s) {
        return '';
    }
    var HORIZONTAL_ELLIPSIS = '\u2026';
    return s && s.length > maxLength ? s.substr(0, maxLength) + HORIZONTAL_ELLIPSIS : s;
}
exports.elideIfLong = elideIfLong;
function localizedDateTime(value) {
    return formatAsDate(value, Localize_1.Formatters.formatMediumDateTimeWithoutSeconds);
}
exports.localizedDateTime = localizedDateTime;
function formatAsDate(value, formatter) {
    if (!formatter) {
        return '';
    }
    if (_.isDate(value)) {
        return formatter(value);
    }
    else if (_.isString(value)) {
        return formatter(new Date(value));
    }
    return '';
}
//# sourceMappingURL=L10n.js.map